import { Color } from 'lib/Button';
import { Color as ChipColor } from 'lib/Chip';

export enum BannerType {
  NONE = '',
  INFO = 'INFO',
  INFO_ALT = 'INFO_ALT',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}

export interface BannerButtonSettings {
  actionCallback?: (campaignId?: string) => void;
  buttonLabel?: string;
  isDisabled?: boolean;
}

export type BannerBackButtonSettings = BannerButtonSettings & { isChange?: boolean };

export interface BannerChipSettings {
  label: string;
  color: ChipColor;
  truncateLabel?: boolean;
}

export const backgroundColorStyle = {
  [BannerType.INFO]: 'bg-primary-600',
  [BannerType.INFO_ALT]: 'bg-purple-300',
  [BannerType.WARNING]: 'bg-yellow-200',
  [BannerType.ERROR]: 'bg-pinkRed-200',
};

export const borderColorStyle = {
  [BannerType.INFO]: 'border-primary-600',
  [BannerType.INFO_ALT]: 'border-purple-300',
  [BannerType.WARNING]: 'border-yellow-200',
  [BannerType.ERROR]: 'border-pinkRed-200',
};

export const containerBackgroundColorStyle = {
  [BannerType.INFO]: 'bg-primary-600',
  [BannerType.INFO_ALT]: 'bg-neutral-100-opacity-50 rounded-md',
  [BannerType.WARNING]: 'bg-yellow-200',
  [BannerType.ERROR]: 'bg-pinkRed-200',
};

export const fontColorStyle = {
  [BannerType.INFO]: 'text-neutral-50',
  [BannerType.INFO_ALT]: 'text-purple-700',
  [BannerType.WARNING]: 'text-yellow-950',
  [BannerType.ERROR]: 'text-pinkRed-950 ',
};

export const confirmButtonStyle = {
  [BannerType.INFO]: 'text-primary-600 hover:bg-white',
  [BannerType.INFO_ALT]: 'text-primary-50 bg-primary-700',
  [BannerType.WARNING]: 'text-primary-600 hover:bg-white0',
  [BannerType.ERROR]: 'text-pinkRed-50 !bg-pinkRed-800 hover:bg-pinkRed-800',
};

export const confirmButtonBackgroundColorStyle = {
  [BannerType.INFO]: Color.BLACK_AND_WHITE,
  [BannerType.INFO_ALT]: Color.PRIMARY,
  [BannerType.WARNING]: Color.BLACK_AND_WHITE,
  [BannerType.ERROR]: Color.BLACK_AND_WHITE,
};
